<template>
    <div class="test-tinymce-editor">
        <tinymce-editor
            api-key="no-api-key"
            v-model="text"
            :disabled="disabled"
            plugins="code table charmap autolink link lists media visualblocks image imagetools paste fullscreen autoresize"
            toolbar="forecolor backcolor bold italic | numlist bullist media | alignleft aligncenter alignright outdent
                indent | code charmap visualblocks | link image embedgooglemap fileattach | fullscreen"
            :init="{
                skin_url: '/js/tinymce/skins/ui/oxide',
                content_css: '/css/tinymce.css',
                imagetools_toolbar: 'imageoptions',
                contextmenu: `link image inserttable | cell row column deletetable`,
                branding: false,
                language: this.locale,
                br_in_pre: false,
                menubar: false,
                paste_data_images: false,
                automatic_uploads: false,
                image_title: true,
                file_picker_types: false,
                relative_urls : false,
                remove_script_host : true,
                min_height: 100,
                mobile: false,
                statusbar: false,
                autoresize: true,
                body_class: 'test-tinymce-editor',
           }"
        ></tinymce-editor>
    </div>
</template>

<script>
import Editor from '@tinymce/tinymce-vue';
import {mapGetters} from "vuex";

export default {
    name: "TestTinymceEditor",
    components: {
        'tinymce-editor': Editor
    },
    props: {
        value: String,
        disabled: {
            type: Boolean,
            default: false,
        }
    },
    computed: {
        ...mapGetters('tests', [
            'locale',
        ]),
        text: {
            set(value) {
                this.$emit('input', value);
            },
            get() {
                return this.value;
            }
        }
    }
}
</script>

<style lang="scss">
.test-tinymce-editor {
    width: 100%;
    .tox {
        &.tox-tinymce {
            border-radius: 6px;
        }

        .tox-toolbar__group {
            border-right-color: #000;
            margin-top: 1.5px;
        }

        .tox-tbtn {
            width: 30px;
            height: 30px;
        }

        .tox-split-button__chevron {
            width: 16px;
        }
    }
}
</style>
